module.exports = __webpack_public_path__ + "static/media/3.0a8401e1.JPG";